<template>
  <form class="stock-notification-form" @submit.prevent="handleFormSubmit">
    <TextField
      :value="email"
      :validation="v$.email"
      type="email"
      autocomplete="email"
      placeholder="Email Address"
      aria-label="Email Address"
      @input="(value) => (email = value)"
    />
    <Button type="submit" width="full">
      {{ buttonText }}
    </Button>
  </form>
</template>

<script>
import Button from "@/components/ButtonV3.vue";

import useVuelidate from "@vuelidate/core";
import { email, helpers, required } from "@vuelidate/validators";
import { mapGetters, mapState, mapActions } from "vuex";
import { klaviyoLists } from "@/config";
import TextField from "@/components/TextField.vue";
import { bisEvent } from "@/helpers/events.js";

export default {
  name: "StockNotificationForm",
  components: {
    Button,
    TextField,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      email: "",
      success: false,
      submitted: false,
    };
  },
  computed: {
    ...mapState("product", ["selectedVariant"]),
    ...mapGetters("app", ["currencyCode"]),
    buttonText() {
      return this.submitted && this.success
        ? "Subscribed for stock alert"
        : "Notify me when available";
    },
  },
  methods: {
    ...mapActions("add-to-bag", ["showCompactStockNotif"]),
    async handleFormSubmit() {
      const currencycCode = this.currencyCode.toLowerCase();
      const klaviyo = klaviyoLists[currencycCode];

      this.v$.email.$touch();
      if (this.v$.email.$invalid) {
        return;
      }

      const variantId = this.selectedVariant.id.split("ProductVariant/")[1];

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: this.email,
                },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-05-15",
        },
        body: JSON.stringify(payload),
      };

      const bisResponse = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${klaviyo.accountId}`,
        requestOptions
      );

      if (bisResponse.status === 202) {
        this.success = true;
        this.submitted = true;

        bisEvent();

        setTimeout(() => {
          this.showCompactStockNotif({
            product: null,
            variant: null,
            show: false,
          });
        }, 3000);
      } else {
        this.success = false;
        this.submitted = true;
      }
    },
  },
  validations() {
    return {
      email: {
        required: helpers.withMessage(
          "Please enter a valid Email Address",
          required
        ),
        email: helpers.withMessage("Please enter a valid Email Address", email),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.stock-notification-form {
  margin-bottom: 8px;

  .field {
    margin-bottom: 8px;
  }
}
</style>
